/**
 * @file deafHardOfHearingPreK.js
 * @author Jake Stark
 * @desc deafHardOfHearingPreK report plugin

*/

/**
 * @module deafHardOfHearingPreK 
 * @desc deafHardOfHearingPreK report plugin
 */

define('plugins/deafHardOfHearingPreK',["underscore",
        "models", "cardboard/models", "cardboard/collections", "cardboard/util", "cardboard/pluginPieces", "text!plugins/templates/deafHardOfHearing_partByProg_table.html!strip", "text!plugins/templates/deafHardOfHearing_3rdGrAchievement_table.html!strip", "text!plugins/templates/deafHardOfHearing_proficiencyIdentification_table.html!strip", "text!plugins/templates/deafHardOfHearing_proficiencyHearingLoss_table.html!strip"
    ],
    function(_,
        ECLDSModels, CardboardModels, CardboardCollections, Util, PluginPieces,
        partByProgTemplate, achieveTemplate, proficiencyIdentificationTableTemplate, proficiencyHearingLossTableTemplate) {

        console.log("MODULE: deafHardOfHearingPreK");

      //  var FY = location.hash.substring(location.hash.indexOf("FISCAL_YEAR--") + 13, location.hash.indexOf("FISCAL_YEAR--") + 17);

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                noOrgFinderSchool: true,
                orgFinderDistrict: true,
                forcedSummaryFilters: ["FISCAL_YEAR", "SUBJECT", "RACE_ETHTYPE"],
                definitionsECLDS: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "Lang",
                    explanationText: "<p>This chart shows the percent of children who are deaf or hard of hearing (D/HH), reported to Minnesota Department of Health's (MDH) Early Hearing Detection and Intervention (EHDI) program who have ever participated in early care and education programs. </p><p>Data in the chart may not be complete for children born in 2007, legislation for mandatory reporting was passed in the spring of 2007. </p>",
                    openByDefault: true,

                    views: [{
                            type: "template",
                            template: "NOTE:  Data includes children reported to MDH's EHDI program who have some degree of hearing loss. </p> <button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                        }, 
                        {
                            type: "template",
                            template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                            dataSourceName: "data",
                            dataPath: "dataSets.DHHParticipationByProgram"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataSetPath: "dataSets.DHHParticipationByProgram",
                            yAxisMax: 100,
                            title: "",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,

                            // DISPLAY
                            // xAxisLabelPath: "label",
                            unitString: "%",
                            showLegend: false,
                            colorByPoint: true,
                            unitDec: 1,
                            disableLegendClick: false,
                            exportToPDF: true,
                            hideContext: true,

                            // SERIES
                            series: [{
                                seriesDisplayNamePath: "program",
                                // seriesDisplayName: "programName",
                                dataPath: "",
                                valuePath: "percent",
                                displayNamePath: "program",
                             //   colors: ["orange", "orange", "orange", "orange"],

                            }],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },

                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "dataSets.DHHParticipationByProgram",
                            template: partByProgTemplate,
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                }, {
                title: "D/HH 3rd Grade Achievement",
                explanationText: "<p>This chart shows 3rd grade achievement levels for children who are deaf or hard of hearing reported to MDH’s EHDI program.</p><p>The tests given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes in tested standards. Children who did not take the test are not included in this chart or the statewide average.  If child repeated 3rd grade and took more than one test, the most recent test score is included here.</p> <p>Data in the chart may not be complete for children born in 2007, as legislation for mandatory reporting to the Department of Health was passed in the spring of 2007.</p><p>More information about the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=MDE034819&RevisionSelectionMethod=latestReleased&Rendition=primary'  target='_blank'>public programs included in ECLDS</a> is available.</p>",
                openByDefault: false,

                views: [{
                    type: "template",
                    template: "<p class='red'>Due to COVID-19, no 2020 summarized assessment data for MCA or MTAS is available.</p> <p>NOTE: Data includes children reported to MDH’s EHDI program who have some degree of hearing loss. </p><p>NOTE: For the 2020-21 school year, the participation rates for both math and reading assessments in 3rd grade was 85%. Historically, the participation rates were higher than 95%. Visit the Minnesota Report Card for more information about 3rd graders’ <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--R__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>reading test participation</a> or <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--M__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>math test participation</a> in your area. </p><button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                }, 
                {
                    type: "template",
                    template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                    dataSourceName: "data",
                    dataPath: "dataSets.DHH3rdGradeAchievement"
                },
                {
                    // SETUP
                    type: "stackedColumn",
                   dataSourceName: "data",
                    dataSetPath: "dataSets.DHH3rdGradeAchievement",

                    // "pointsWithinRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "row", like so:
                    //	 +---------+
                    //	 | X X X X |
                    //	 | . . . . |
                    //	 | . . . . |
                    //	 | . . . . |
                    //	 +---------+
                   dataShape: "pointsAcrossRows",
							convertDataHashToArray: true,
							dataDimensions: 1,

                    // DISPLAY
                    unitString: "%",
       				xAxisLabelPath: "[0].program",

                    showLegend: true,
                    disableLegendClick: false,
                    exportToPDF: true,
                    hideContext: true,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        //valuePath: "[0].percent",
                        seriesDisplayName: "Exceeds",
                        valuePath: "[0].percent",
                    }, {
                        seriesDisplayName: "Meets",
                        valuePath: "[1].percent",
                    },{
                        seriesDisplayName: "Partially Meets",
                        valuePath: "[2].percent",
                    },{
                        //valuePath: "[0].percent",
                        seriesDisplayName: "Doesn't Meet",
                        valuePath: "[3].percent",
                    },                   ],
                    errorConditions: [PluginPieces.standardErrorCondition]
                },
                {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.DHH3rdGradeAchievement",
                    template: achieveTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }]
            },
           /* {
                title: "3rd Grade Proficiency by Age of Identification",
                explanationText: "<p>This chart shows 3rd grade proficiency scores for children who are deaf or hard of hearing reported to MDH’s EHDI program by age of identification, by 90 days of age or greater than 90 days of age.  Identification of hearing loss by 90 days of age is a <a href='http://pediatrics.aappublications.org/content/120/4/898.full?ijkey=oj9BAleg21OIA&keytype=ref&siteid=aapjournals' target='_blank'>national goal of the EHDI program.</a></p><p>Data includes all children reported to MDH newly identified with a hearing loss and includes children who may have had normal hearing at birth and developed hearing loss later. </p> <p>The proficiency tests given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes in tested standards. Children who did not take the proficiency test are not included in this chart. Data in the chart may not be complete for children born in 2007, legislation for mandatory reporting was passed in the spring of 2007.</p>",
                openByDefault: false,

                views: [ {
                    type: "template",
                    template: "<p>NOTE: Data includes children reported to MDH’s EHDI Program whose hearing loss was identified by 90 days of age or greater than 90 days of age. </p><button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.children[0].id);'>Export to PDF</button>"
                }, {
                    // SETUP
                    type: "stackedColumn",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByAgeOfIdentification",

                    // "pointsAcrossRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "column", like so:
                    //	 +---------+
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 +---------+
                    // To wrap your head around this, watch iteration in your debugger in
                    // pointsAcrossRows() in transforms.js.
                    dataShape: "pointsAcrossRows",
                    convertDataHashToArray: true,
                    dataDimensions: 2,
                   // unitDec: 1,
                    title: "",

                    // DISPLAY
                    xAxisLabelPath: "ageOfIdentification",
                    legendReversed: false,
                    unitString: "%",
                    exportToPDF: true,
                    hideContext: true,
                    stackLabels: false,

                    showLegend: true,
                    disableLegendClick: false,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        valuePath: "legend[0].percent",
                        seriesDisplayName: "Not Proficient",
                    }, {
                        valuePath: "legend[1].percent",
                        seriesDisplayName: "Proficient",
                    }],
                    errorConditions: [PluginPieces.standardErrorCondition]
                }, {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByAgeOfIdentification",
                    template: proficiencyIdentificationTableTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }]
            },*/
            {
                title: "3rd Grade Proficiency by Degree of Hearing Loss",
                explanationText: "<p>This chart shows 3rd grade proficiency scores for children who were identified through Newborn Screening as are deaf or hard of hearing and reported to MDH’s EHDI program. Children are grouped into those identified, by 90 days of age and those identified after 90 days of age. Identification of congenital hearing loss by 90 days of age is a <a href='http://pediatrics.aappublications.org/content/120/4/898.full?ijkey=oj9BAleg21OIA&keytype=ref&siteid=aapjournals'>national goal of the EHDI program</a>.</p><p>Data include all children identified through Newborn Screening as deaf or hard of hearing and reported to MDH. Data exclude children who had normal or unknown hearing status at birth and were identified as deaf or hard of hearing later.  </p> <p>The proficiency tests given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes in tested standards. Children who did not take the proficiency test are not included in this chart. Data in the chart may not be complete for children born in 2007, legislation for mandatory reporting was passed in the spring of 2007.</p>",
                openByDefault: false,

                views: [ {
                    type: "template",
                    template: "<p class='red'>Due to COVID-19, no 2020 summarized assessment data for MCA or MTAS is available.</p> <p>NOTE:  Degree of hearing loss refers to the unaided severity of the child’s hearing loss as reported by the child’s audiologist.  This data includes children reported to MDH’s EHDI program who have some degree of hearing loss ranging from slight to profound in one or both ears. </p><p>NOTE: For the 2020-21 school year, the participation rates for both math and reading assessments in 3rd grade was 85%. Historically, the participation rates were higher than 95%. Visit the Minnesota Report Card for more information about 3rd graders’ <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--R__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>reading test participation</a> or <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--M__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>math test participation</a> in your area. </p><button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                }, 
                {
                    type: "template",
                    template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                    dataSourceName: "data",
                    dataPath: "dataSets.thirdGradeProficiencyByDegreeOfHearingLoss"
                },
                {
                    // SETUP
                    type: "stackedColumn",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByDegreeOfHearingLoss",

                    // "pointsAcrossRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "column", like so:
                    //	 +---------+
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 +---------+
                    // To wrap your head around this, watch iteration in your debugger in
                    // pointsAcrossRows() in transforms.js.
                    dataShape: "pointsAcrossRows",
                    convertDataHashToArray: true,
                    dataDimensions: 2,
                   // unitDec: 1,
                    title: "",

                    // DISPLAY
                    xAxisLabelPath: "degreeOfHearingLoss",
                    legendReversed: false,
                    unitString: "%",
                    exportToPDF: true,
                    hideContext: true,
                    stackLabels: false,

                    showLegend: true,
                    disableLegendClick: false,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        valuePath: "legend[0].percent",
                        seriesDisplayName: "Not Proficient",
                    }, {
                        valuePath: "legend[1].percent",
                        seriesDisplayName: "Proficient",
                    }],
                    errorConditions: [PluginPieces.standardErrorCondition]
                }, {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByDegreeOfHearingLoss",
                    template: proficiencyHearingLossTableTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }]
            }],

            filterSources: {
               orgs: {
                    modelType: ECLDSModels.ECLDSOrgList,
                    //url: "/data/state.json",
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_orgid_economicfoodassistance.fex",
                    noViewParams: true,
                    enabled: true
                },

                filters: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_fiscal_year2015.fex",
                       defaultParams: ["FISCAL_YEAR=2016"],
                       filterParam: {
                          fiscalYear: "2016"
                       },
                    enabled: false,
                    modelType: CardboardModels.FilterData
                },

                filters2: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    //   filterParam: {
                    //       fiscalYear: "2015"
                    //   },
                       defaultParams: ["FISCAL_YEAR=2016"],
                    urls: {
                        //filterForReport: "data/filters.json"
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_deafHardOfHearing.fex"
                    },

                    // specify the order of filters, by name (filterUrl in database terms)
                   // filterOrder: ["GENDER", "RACE_ETHNICITY", "OTHER_CRITERIA"],

                    enabled: true,
                    noViewParams: false
                },

                demographicCategories: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_deafHardOfHearing_nbr2.fex",
                    enabled: true,
                    modelType: CardboardCollections.DemoCatProducer,
                    noViewParams: false
                }
            },

            dataSources: {
                data: {
                    modelType: CardboardModels.Model,
                    // url: "/data/mocks/preGradData.json",
                    // url: "/data/mocks/preGradData_statewide.json",
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_sec_o_deafHardOfHearing.fex",
                    yearPath: "meta.fiscalYear",
                    //  defaultParams: {
                    //	orgId: 999999000,
                    //      COHORTID: 2014
                    //	},
                    enabled: true,
                    errorConditions: [PluginPieces.standardErrorCondition]

                }

            }
        };

        return exports;
    });
